(() => {
  const STORAGE_KEY = 'clothsvilla_delivery_pincode';
  const cleanCsv = (value) => String(value || '').split(',').map((v) => v.trim()).filter(Boolean);
  const addWorkingDays = (start, days) => {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added += 1;
    }
    return d;
  };
  const formatDate = (date) => new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' }).format(date);

  if (!customElements.get('cv-delivery-checker')) {
    customElements.define('cv-delivery-checker', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.input = this.querySelector('[data-cv-pincode]');
        this.button = this.querySelector('[data-cv-check]');
        this.result = this.querySelector('[data-cv-delivery-result]');
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved && this.input) this.input.value = saved;
        this.button?.addEventListener('click', () => this.check());
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') { event.preventDefault(); this.check(); }
        });
        if (saved && this.dataset.autoCheck === 'true') this.check();
      }
      check() {
        const pin = String(this.input?.value || '').replace(/\D/g, '').slice(0, 6);
        if (this.input) this.input.value = pin;
        if (!/^[1-9][0-9]{5}$/.test(pin)) return this.show('Please enter a valid 6-digit Indian pincode.', true);
        const excluded = cleanCsv(this.dataset.excludedPrefixes);
        const blocked = excluded.some((value) => pin === value || pin.startsWith(value));
        if (blocked) return this.show('Delivery is currently unavailable for this pincode. Please contact WhatsApp support.', true);
        localStorage.setItem(STORAGE_KEY, pin);
        let minDays = Number(this.dataset.minDays || 3);
        let maxDays = Math.max(Number(this.dataset.maxDays || 6), minDays);
        const remote = cleanCsv(this.dataset.remotePrefixes);
        if (remote.some((value) => pin.startsWith(value))) {
          const extra = Number(this.dataset.remoteExtraDays || 2);
          minDays += extra; maxDays += extra;
        }
        const from = addWorkingDays(new Date(), minDays);
        const to = addWorkingDays(new Date(), maxDays);
        const cod = this.dataset.codEnabled === 'true'
          ? '<div class="cv-delivery-checker__row">✓ Cash on Delivery available</div>'
          : '<div class="cv-delivery-checker__row">Prepaid payment only</div>';
        const shipping = this.dataset.freeShipping === 'true'
          ? '<div class="cv-delivery-checker__row">✓ Free shipping available</div>' : '';
        this.show(`<div class="cv-delivery-checker__row">✓ Estimated delivery: <strong>${formatDate(from)}–${formatDate(to)}</strong></div>${cod}${shipping}`, false, true);
      }
      show(message, error = false, html = false) {
        if (!this.result) return;
        this.result.hidden = false;
        this.result.classList.toggle('is-error', error);
        if (html) this.result.innerHTML = message; else this.result.textContent = message;
      }
    });
  }

  const selectedOptionsText = (root) => {
    if (!root) return '';
    const values = [];
    root.querySelectorAll('variant-selects select').forEach((select) => {
      const label = select.closest('.product-form__input')?.querySelector('label')?.textContent?.trim();
      const value = select.selectedOptions?.[0]?.textContent?.trim();
      if (value) values.push(label ? `${label}: ${value}` : value);
    });
    root.querySelectorAll('variant-selects input[type="radio"]:checked').forEach((input) => {
      const fieldset = input.closest('fieldset');
      const label = fieldset?.querySelector('legend')?.textContent?.trim();
      const value = input.value || input.dataset.optionValue;
      if (value) values.push(label ? `${label}: ${value}` : value);
    });
    return [...new Set(values)].join(', ');
  };

  if (!customElements.get('cv-whatsapp-size-help')) {
    customElements.define('cv-whatsapp-size-help', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.link = this.querySelector('a');
        this.productInfo = this.closest('product-info');
        this.updateLink = this.updateLink.bind(this);
        this.updateLink();
        this.productInfo?.addEventListener('change', this.updateLink);
        window.addEventListener('popstate', this.updateLink);
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.updateLink);
        window.removeEventListener('popstate', this.updateLink);
      }
      updateLink() {
        if (!this.link) return;
        const options = selectedOptionsText(this.productInfo);
        const title = this.dataset.productTitle || document.title;
        const messageParts = [this.dataset.greeting || 'Hello Clothsvilla, please help me choose the correct size for:', title];
        if (options) messageParts.push(`Selected options: ${options}`);
        messageParts.push(window.location.href);
        this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(messageParts.join('\n'))}`;
      }
    });
  }
})();
